<kendo-grid [kendoGridBinding]="this.kopHistory" class="kendo-grid-custom" [sortable]="true" 
        [style]="{ height: '100%' }"    
        [selectable]="true" (selectionChange)="this.gridSelectionChanged($event)">
    <kendo-grid-column field="date" title="Date" [width]="200">
        <ng-template kendoGridCellTemplate let-dataItem>
            @if (dataItem.id != undefined) {
                <span class="htime">{{dataItem.date | date:'dd-MM-yyyy HH:mm:ss'}}</span>

            } @else {
                <span class="htime">{{'Last' | translate: 'Last'}}</span>
            }
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="user" title="user" [width]="150">
    </kendo-grid-column>
    <kendo-grid-column field="comments" title="comments">
    </kendo-grid-column>

</kendo-grid>
